import { ProductTypeConstant } from "../../../Core/Constant/Product/ProductTypeConstant";

/***
 * 判斷產品 type 是否為 tour
 * true: 將 tour_key, group_code 取出放進 ApiQueryParsed
 *
 * tour: [
 *  {
 *      group_code: XXX,
 *      tour_key: XXX
 *  },
 * ]
 */
export function tourApiQueryCombination() {

  // 
  let _getApiQueryAfterCombination = async function (theme_product_detail_list) {
    let api_query_list = [];
    theme_product_detail_list.forEach(function (list_item) {
      list_item.forEach(function (item) {
        if (item.product_type == ProductTypeConstant.PRODUCT_TYPE_TOUR) {
          let ApiQueryParsed = {};
          ApiQueryParsed.tour_key = item.tour_key;
          ApiQueryParsed.group_code = item.group_code;
          api_query_list.push(ApiQueryParsed);
        }
      });
    });

    return api_query_list;
  };

  let _getApiQueryAfterCombinationByGetMethod = async function (theme_product_detail_list) {
    let key = 0;
    let api_query = "";
    theme_product_detail_list.forEach(function (list_item, index) {
      list_item.forEach(function (item, i) {
        if (item.product_type == ProductTypeConstant.PRODUCT_TYPE_TOUR) {
          api_query += "tour" + "[" + key + "]" + "[group_code]=" + item.group_code + "&" + "tour" + "[" + key + "]" + "[tour_key]=" +item.tour_key + "&";
          key++;
        }
      });
      if (index + 1 == theme_product_detail_list.length) {
        api_query = api_query;
      }
    });

    return api_query;
  };

  return {
    getApiQueryAfterCombination: _getApiQueryAfterCombination,
    getApiQueryAfterCombinationByGetMethod: _getApiQueryAfterCombinationByGetMethod,
  };
}
